import {useCallback, useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

export const LetterSpacing = () => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [charSpacing, setCharSpacing] = useState();
  const editorDisabled = useSelector(selectEditorDisabled);

  useEffect(() => {
    const updateCharSpacing = () => setCharSpacing(canvas?.getActiveObjects()?.[0]?.charSpacing);

    updateCharSpacing();
    canvas?.on('object:reset', updateCharSpacing);

    return () => {
      canvas?.off('object:reset', updateCharSpacing);
    };
  }, [canvas, activeObjects]);

  const onChangeHandler = useCallback(
    (value) => {
      activeObjects.forEach((obj) => {
        setCharSpacing(value);
        obj.set('charSpacing', value);
      });

      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [activeObjects]
  );

  return (
    <Range
      min={0}
      max={100}
      step="10"
      suffix="%"
      onChange={onChangeHandler}
      value={charSpacing}
      disabled={editorDisabled}
      dataQaId="step1-textspacing-range"
    />
  );
};
